import { FC, memo, useState } from 'react'
import spclasses from '../../../SetCourseClassDirectionModal/purchase.module.css'
import { CheckBoxLabel } from '@UI/CheckBox'
import InfoComp from '@pages/Admin/CRMSettings/components/InfoComp/InfoComp'
import SliderField from '@pages/Admin/CourseSettings/components/SliderField/SliderField'
import SelectTariffValue from '@pages/CoursesCatalog/modals/CourseEnrollmentModal/components/SelectTariffValue/SelectTariffValue'
import classes from './index.module.css'

export interface PaymentPeriodCheckboxProps {
  value?: number | null | undefined
  onChange?: (value: number | null | undefined) => void
  type: 'course' | 'class'
  courseTariff?: ICourseTariff | null
}

const PaymentPeriodCheckbox: FC<PaymentPeriodCheckboxProps> = memo(
  ({ value, onChange, type, courseTariff }) => {
    const [isChecked, setIsChecked] = useState(!!value)

    const handleCheckboxChange = (checked: boolean) => {
      setIsChecked(checked)
      if (!checked) {
        onChange?.(null)
      } else onChange?.(1)
    }

    const handleChange = (value: number | null) => {
      if (value) onChange?.(value)
      else onChange?.(null)
    }

    return (
      <div className={spclasses.inputWithLabel}>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <CheckBoxLabel
            type="button"
            value={isChecked}
            onClick={() => handleCheckboxChange(!isChecked)}
            label="Зафиксировать период оплаты"
            className={spclasses.checkboxWithLabel}
            style={{
              justifyContent: 'flex-start',
              paddingTop: '4px',
              paddingBottom: '4px',
              height: 'auto',
            }}
          />
          <InfoComp text="По умолчанию клиент, при покупке сам выбирает, на какое кол-во месяцев или часов ему оплатить обучение. При включении данного чебкокса вы фиксируете кол-во месяцев, дней или часов" />
        </div>
        {isChecked && type === 'course' && courseTariff ? (
          <div
            style={{ paddingLeft: '8px', paddingTop: '4px' }}
            className={classes.selectTariffValueWrapper}
          >
            <SelectTariffValue
              value={value ?? 1}
              setValue={handleChange}
              tariff={{
                ...courseTariff,
                has_demo: false,
              }}
              demo={false}
              onChangeDemo={() => {}}
            />
          </div>
        ) : isChecked && type === 'class' ? (
          <div style={{ paddingLeft: '8px', paddingTop: '4px' }}>
            <SliderField
              label={'Период'}
              value={value ?? 1}
              extraContent={(value ?? 1).toString()}
              min={1}
              max={24}
              onChange={handleChange}
            />
          </div>
        ) : null}
      </div>
    )
  },
)

export default PaymentPeriodCheckbox
